import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, DATE_FORMAT, TOKEN_TYPE } from '../../../constants/constants';
import { getData, getHeaders } from '../../../http/request';
import { format } from 'date-fns';

export const PROTOCOLS_ACTION_TYPES = {
	GET_PROTOCOLS_SUCCESS: 'GET_PROTOCOLS_SUCCESS',
    POST_PROTOCOL_SUCCESS: 'POST_PROTOCOL_SUCCESS',
    PUT_PROTOCOL_SUCCESS: 'PUT_PROTOCOL_SUCCESS',
    DELETE_PROTOCOL_SUCCESS: 'DELETE_PROTOCOL_SUCCESS',
    UPDATE_PROTOCOLS_PAGINATION: 'UPDATE_PROTOCOLS_PAGINATION'
};

const PROTOCOLS_URL = `${ENTRYPOINT}${API_ROUTES.PROTOCOLS}`;
const PRINT_PROTOCOLS_URL = `${ENTRYPOINT}${API_ROUTES.PRINT_PROTOCOLS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { startDate, endDate, customer } = filters;
    let filterParams = params;
    if (startDate) {
        filterParams = `${filterParams}&startDate[after]=${format(startDate, DATE_FORMAT)}`;
    }
    if (endDate) {
        filterParams = `${filterParams}&endDate[before]=${format(endDate, DATE_FORMAT)}`;
    }
    if (customer) {
        const { uuid: customer_uuid } = customer;
        filterParams = `${filterParams}&customer=${customer_uuid}`;
    }
    return filterParams;
}

export const getProtocols = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_PROTOCOLS_URL = `${PROTOCOLS_URL}${params}`;
        const response = await getData(GET_PROTOCOLS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: PROTOCOLS_ACTION_TYPES.GET_PROTOCOLS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: PROTOCOLS_ACTION_TYPES.UPDATE_PROTOCOLS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getProtocol = async (uuid) => {
    const GET_PROTOCOL_URL = `${PROTOCOLS_URL}/${uuid}`;
    return await getData(GET_PROTOCOL_URL, getHeaders());
}

export const updateProtocolsPagination = ({ rowsPerPage, page = 0, filters }) =>
    (dispatch) => {
        dispatch({ type: PROTOCOLS_ACTION_TYPES.UPDATE_PROTOCOLS_PAGINATION, payload: { rowsPerPage, page, filters } });
    }

export const printProtocols = (data) => {
    let params = getPaginationParams(data);
    const { filters } = data;
    params = getFilterParams(params, filters);
    return async () => await getData(`${PRINT_PROTOCOLS_URL}${params}`);
}
